import "./style.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import PanelLayout from "../../panelComponents/PanelLayout/PanelLayout";
import authService from "../../../service/auth";
import {
  List,
  ListBody,
  ListFilterButtons,
  ListRowActions,
  ListWrapper,
  TaxReturnStatus,
} from "../../../BTUI/List";
import { useDispatch, useSelector } from "react-redux";
import { setTaxfileFilter } from "../../../store/userSlice";
import { STATUS_COLOR } from "../../../utils/constants";
import { hideLoader, showLoader } from "../../../BTUI/BtLoader";
import { Button } from "../../../components/Button";
import { Popup } from "../../../components/Form";
import AskForPaymentNrc from "../payments/AskForPaymentNrc";
import { IconCopy, IconRefresh, IconVerify } from "../../../BTUI/Icons";
import { toastError, toastSuccess } from "../../../BTUI/BtToast";

const NrcPaymentRequests = () => {
  const [list, setList] = useState(null);
  const [clientMessage, setClientMessage] = useState([]);
  const [taxfileStatus, setTaxfileStatus] = useState([]);
  const [showAskPayment, setShowAskPayment] = useState(false);
  const [verificationConfirm, setVerificationConfirm] = useState(null);
  const [copySuccess, setCopySuccess] = useState({});
  const navigate = useNavigate();

  const { taxfileFilter = [], user } = useSelector((store) => store?.user);

  const fetchList = () => {
    showLoader();
    authService
      ?.getNrcPaymentRequests()
      .then((res) => {
        setList(res?.data?.response?.list);
        hideLoader();
      })
      .catch((err) => {
        console.log(err);
        hideLoader();
      })
      .finally(() => hideLoader());
  };

  useEffect(() => {
    fetchList();
  }, [taxfileFilter]);

  useEffect(() => {
    authService
      .dashUserMsgListCount()
      .then((res) => {
        setClientMessage(res?.data?.response?.list);
      })
      .catch((err) => {
        console.log("Error in Get Client Messages", err);
      });

    authService
      .getTaxfileStatus()
      .then((res) => {
        setTaxfileStatus(
          res?.data?.response?.taxfileStatusList?.map((itm) => {
            return {
              value: itm?.code,
              title: itm?.name,
              bgColor: STATUS_COLOR?.[itm?.code]?.bgColor,
              textColor: STATUS_COLOR?.[itm?.code]?.color,
            };
          })
        );
      })
      .catch((err) => {
        // console.log(err)
      });
  }, []);

  const handleAskForPaymentClose = () => {
    fetchList();
    setShowAskPayment(false);
  };

  const handleCopyUrl = (url, id) => {
    navigator.clipboard
      .writeText(url)
      .then(() => {
        setCopySuccess((prev) => ({ ...prev, [id]: "Copied!" }));
        setTimeout(() => {
          setCopySuccess((prev) => ({ ...prev, [id]: null }));
        }, 800);
      })
      .catch(() => {
        setCopySuccess((prev) => ({ ...prev, [id]: "Copy Failed!" }));
      });
  };

  const handleRefresh = (id) => {
    authService
      .refreshPaymentOrderStatus(id, {})
      .then((res) => {
        fetchList();
        toastSuccess(res?.data?.message);
      })
      .catch((err) => {
        toastError(err?.data?.message);
      });
  };

  const handleVerification = (id) => {
    authService
      .verifyPaymentOrder(id, {})
      .then((res) => {
        fetchList();
        toastSuccess(res?.data?.message);
        setVerificationConfirm(null);
      })
      .catch((err) => {
        toastError(err?.data?.message);
      });
  };

  return (
    <PanelLayout>
      <Popup
        maxWidth="30em"
        trigger={verificationConfirm}
        setTrigger={() => setVerificationConfirm(null)}
      >
        Veriy amount {verificationConfirm?.amount} ?
        <br />
        <br />
        <div className="" style={{ display: "flex", gap: "1em" }}>
          <Button
            varient="action-btn primary"
            title="Verify"
            onClick={() => handleVerification(verificationConfirm?.id)}
          />
          <Button
            varient="action-btn sec"
            title="Cancel"
            onClick={() => setVerificationConfirm(false)}
          />
        </div>
      </Popup>

      <Popup
        trigger={showAskPayment}
        setTrigger={() => setShowAskPayment(!showAskPayment)}
      >
        <AskForPaymentNrc setToggleUpdateWindow={handleAskForPaymentClose} />
      </Popup>

      <div className="dashList-section">
        <ListWrapper
          style={{ width: "70%", flexGrow: 2 }}
          title="External Payment Links"
        >
          <Button
            title="Add New "
            varient="action-btn green"
            onClick={() => setShowAskPayment(true)}
          />
          <List
            thead={[
              { title: "Customer", width: "20%" },
              { title: "title", width: "20%" },
              { title: "amount", width: "10%" },
              { title: "payment status", width: "20%" },
              { title: "Verify", width: "10%" },
              { title: "Url", width: "10%" },
              { title: "Created on", width: "10%" },
              { title: "", width: "5%" },
            ]}
          >
            <ListBody>
              {list?.length > 0 ? (
                list?.map((order, index) => {
                  return (
                    <>
                      <tr>
                        <td>{order?.customer_email}</td>
                        <td>{order?.title}</td>
                        <td>{order?.amount}</td>
                        <td>{order?.payment_status}</td>
                        <td>
                          {order?.payment_status == "Paid" ? (
                            <Button
                              maxWidth={"100%"}
                              varient="icon"
                              title={<IconVerify color="green" />}
                              onClick={() =>
                                setVerificationConfirm({
                                  id: order?.id,
                                  amount: order?.amount,
                                  status: "Verified",
                                })
                              }
                            />
                          ) : null}
                        </td>
                        <td>
                          {order.payment_url &&
                            (copySuccess[order.id] ? (
                              <small
                                style={{ marginLeft: "3px", color: "green" }}
                              >
                                {copySuccess[order.id]}
                              </small>
                            ) : (
                              <IconCopy
                                size="1.5em"
                                onClick={() =>
                                  handleCopyUrl(order?.payment_url, order.id)
                                }
                              />
                            ))}
                        </td>
                        <td>
                          {order?.payment_status != "Paid" ? (
                            <Button
                              maxWidth={"100%"}
                              varient="icon"
                              title={<IconRefresh color="blue" />}
                              onClick={() => handleRefresh(order?.id)}
                            />
                          ) : null}
                        </td>
                      </tr>
                    </>
                  );
                })
              ) : (
                <p style={{ textAlign: "center", marginTop: "20px" }}>
                  No Record Found
                </p>
              )}
            </ListBody>
          </List>
        </ListWrapper>
        <ListWrapper style={{ width: "25%", flexGrow: 1 }}>
          <List thead={MessageListThead} title="New Messages">
            <ListBody>
              {clientMessage?.length > 0 ? (
                clientMessage?.map((row, index) => {
                  return (
                    <tr
                      key={index}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        navigate("/executive/message/" + row?.user_id)
                      }
                    >
                      <td>{row?.user_email || row?.firstname}</td>
                      <td className="tax-list-msg-count">
                        <p
                          className={`${
                            row?.client_message_count > 0 ? "green" : "grey"
                          }`}
                        >
                          <span>{row?.client_message_count}</span>
                        </p>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <p style={{ textAlign: "center", marginTop: "20px" }}>
                  No Record Found
                </p>
              )}
            </ListBody>
          </List>
        </ListWrapper>
      </div>
    </PanelLayout>
  );
};

export default NrcPaymentRequests;

const TaxReturnListThead = [
  {
    title: "id",
    width: "5%",
  },
  {
    title: "Name",
    width: "15%",
  },
  {
    title: "Email",
    width: "15%",
  },
  {
    title: "Marital Status",
    width: "13%",
  },
  {
    title: "Province",
    width: "13%",
  },
  {
    title: "Status",
    width: "14%",
  },
  {
    title: "Has Paid ?",
    width: "10%",
  },
  {
    title: "",
    width: "10%",
  },
];

const MessageListThead = [
  {
    title: "Username",
    width: "90%",
  },
  {
    title: "Messages",
    width: "10%",
  },
];
